import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";

export const CTASection = () => {
  const navigate = useNavigate();

  const handleDemoClick = () => {
    console.log('Demo button clicked');
    navigate('/schedule-demo');
  }

  const handleSalesClick = () => {
    console.log('Sales button clicked');
    navigate('/contact-sales');
  }

  return (
    <section className="py-24 bg-white">
      <div className="max-w-4xl mx-auto px-4 text-center">
        <h2 className="text-4xl font-bold mb-8">Ready to Transform Patient Care?</h2>
        <p className="text-xl text-gray-600 mb-12">
          Join leading healthcare providers in revolutionizing post-surgical care
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button 
            className="text-lg px-8 py-6 bg-blue-600 hover:bg-blue-700 text-white rounded-full"
            onClick={handleDemoClick}
          >
            Schedule Demo <ArrowRight className="ml-2" />
          </Button>
          <Button 
            className="text-lg px-8 py-6 bg-white border-2 border-blue-600 text-blue-600 hover:bg-blue-50 rounded-full"
            onClick={handleSalesClick}
          >
            Contact Sales
          </Button>
        </div>
      </div>
    </section>
  );
};